export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig();
    const secureFetch = async (url: string, options: any = {}) => {
        try {
            const response = await useFetch(`${url}`, {
                method: options.method || 'GET', // Default to GET
                headers: {
                    'Authorization': `Bearer ${config.public.apiBearerToken}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: options.body ? JSON.stringify(options.body) : undefined,
                ...options,
            });

            return response;
        } catch (error) {
            console.error(`Secure API Error on ${options.method || 'GET'} ${url}:`, error);
            throw error;
        }
    };

    return {
        provide: {
            secureFetch
        }
    };
});